// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__0gJxc","header":"tab_header__erRYi","content":"tab_content__qy8ou","footer":"tab_footer__DEM9Y","fixed":"tab_fixed__Vi9lG"};